import { defineComponent as _defineComponent } from 'vue'
import PromptDialogComponent from '@/components/Dialog/PromptDialogComponent.vue'
import useDialog from '@/composables/useDialog'
import useFeedback from '@/composables/useFeedback'
import { DialogTypes } from '@/store/modules/dialog/dialogTypes'
import store from '@/store/store'
import { ModuleNamespaces } from '@/store/types/storeGlobalTypes'
import { computed, ref } from 'vue'
import { useI18n } from 'vue-i18n-composable'


export default /*#__PURE__*/_defineComponent({
  __name: 'ChangeStatusDialogComponent',
  props: {
  showDialog: Boolean,
  selection: {
    type: Object,
    default: () => ({})
  }
},
  emits: ['close'],
  setup(__props, { emit: emits }) {

const props = __props;


const { t } = useI18n()
// DEFINE PROPS  ======================================================================================================


const text = {
  title: t('views.actions_all.change_status_title'),
  alert: {
    ok: t('components.alerts.register_save').toString()
  },
  dialog: {
    ko: t('views.actions_all.dialog_ko_message').toString(),
    multiple: (totalChanges: number) => t('views.actions_all.dialog_multiple_message', { totalChanges }).toString()
  }
}

const modalWidth = 940

const parsedFormSchema = computed(() => [
  {
    id: 'stateId',
    lg: 12,
    md: 12,
    xl: 12,
    name: 'stateId',
    attach: false,
    label: 'Estado',
    endPoint: 'action/LLAM/status/get',
    itemName: 'status',
    fieldType: 'LexonAutocompleteComponent',
    itemValue: 'id',
    initializeFirst: true,
    validationRules: 'required'
  },
  ...(hasSubActions.value
    ? [
        {
          id: 'subActionAlertInfo',
          lg: 12,
          md: 12,
          xl: 12,
          name: 'subActionAlertInfo',
          alert: {
            type: 'info-text',
            message: 'Al cambiar el estado a cancelado o finalizado, sus subactuaciones también cambiarán de estado.',
            cancelButton: false
          },
          class: 'static-alert',
          hidden: false,
          fieldType: 'StaticAlertComponent',
          fullWidth: 'true'
        }
      ]
    : [])
])

const formData = ref<any>({})

// COMPUTEDS ==========================================================================================================
const selectedRowsId = computed(() => props.selection.selectedRows.map((action: any) => action.id).join(','))

const payload = computed(() => {
  // if (props.selection.selectAll && props.selection.selectedRows.length > 1) {
  //   return {
  //     idFile: props.selection.idFile,
  //     idType: 'ALL',
  //     idStatusNew: formData.value.stateId,
  //     filters: props.selection.filters,
  //     archived: props.selection.archived,
  //     search: props.selection.search
  //   }
  // }

  return {
    idStatusNew: formData.value.stateId,
    ids: selectedRowsId.value
  }
})

const isMultipleChanges = computed(() => props.selection.selectedRows.length > 1 || props.selection.selectAll)
const totalChanges = computed(() => {
  return props.selection.selectAll ? props.selection.totals : props.selection.selectedRows.length
})

const hasSubActions = computed(() => {
  return props.selection.selectedRows.some((action: any) => action.childCount > 0)
})

// COMPOSABLES   ======================================================================================================
const { getDialog, getDialogError } = useDialog()
const { showFeedbackSuccess } = useFeedback()

// EVENTS =============================================================================================================

const onExecuteAction = (action: string) => {
  if (action === 'save') {
    save()
  }
  if (action === 'close') {
    close()
  }
}

// METHODS ==========================================================================================================
async function saveMassiveAction() {
  const { success } = await store.dispatch(`${ModuleNamespaces.ACTIONS}/massiveUpdateAction`, payload.value)
  if (success) {
    showFeedbackSuccess({ message: text.alert.ok })
    return success
  }
  getDialogError({ message: text.dialog.ko })
}

async function save() {
  if (isMultipleChanges.value) {
    return getDialog({
      type: DialogTypes.INFO,
      message: text.dialog.multiple(totalChanges.value),
      action: async () => {
        const response = await saveMassiveAction()
        close(Boolean(response))
      }
    })
  }

  const response = await saveMassiveAction()
  close(Boolean(response))
}

function close(refresh = false) {
  emits('close', { refresh })
  formData.value = {}
}

return { __sfc: true,emits, t, props, text, modalWidth, parsedFormSchema, formData, selectedRowsId, payload, isMultipleChanges, totalChanges, hasSubActions, getDialog, getDialogError, showFeedbackSuccess, onExecuteAction, saveMassiveAction, save, close, PromptDialogComponent }
}

})